module.exports = __webpack_public_path__ + "static/img/znfp-bg.5951f23.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/appCenter/img/znfp-bg.png
// module id = jdYP
// module chunks = 96